export const getCustomerInitialState = () => ({
    checkedInCustomer: undefined,
    coBuyer: null
});
